import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navLinks = [
    { label: 'Home', id: 'home' },
    { label: 'About Us', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Portfolio', id: 'portfolio' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header 
      className="dark-header"
      style={{
        background: scrolled ? 'rgba(0, 0, 0, 0.95)' : '#000000',
        backdropFilter: scrolled ? 'blur(10px)' : 'none',
        transition: 'all 0.3s ease'
      }}
    >
      <div className="dark-logo-container">
        <img 
          src="https://customer-assets.emergentagent.com/job_logardt-advisory/artifacts/tquvcazv_Consulting%20I%20Web%20development%20I%20AI%20Solutions.png"
          alt="Logardt Group - Consulting | Web development | AI Solutions"
          onClick={() => scrollToSection('home')}
          style={{
            height: '60px',
            width: 'auto',
            cursor: 'pointer',
            transition: 'opacity 0.3s ease'
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.8'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        />
      </div>
      
      <nav className="dark-nav">
        {navLinks.map((link) => (
          <button
            key={link.id}
            onClick={() => scrollToSection(link.id)}
            className="dark-nav-link"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            {link.label}
          </button>
        ))}
      </nav>
    </header>
  );
};

export default Header;
